import { object } from 'zod';

import { ProductCountingRoundStrategySchema } from '../product-counting-round-strategy/product-counting-round-strategy.validation';
import { ProductGroupsSchema } from '../product-groups/product-groups.validation';

export const BaseEarnSchema = object({
  roundMoneyAmount: ProductCountingRoundStrategySchema,
  ineligibleProductGroups: ProductGroupsSchema,
});
